export const getEnvironment = () => {
    const hostname = window?.location?.hostname;
    const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '::1';
    const isDevelopment = (process.env.REACT_APP_ENV || process.env.NODE_ENV) === 'development';

    if (isLocalhost) {
        return 'localhost';
    } else if (isDevelopment) {
        return 'development';
    } else {
        return 'production';
    }
}

const environment = getEnvironment()
const BASE_URL = environment === 'localhost' ? "http://localhost:8082/v1" : (environment === 'development' ? "https://dev.api.ateasesolutions.com/v1" : "https://api.ateasesolutions.com/v1")
// const BASE_URL = () => {
//     if (environment === 'localhost') {
//         return "http://localhost:8082"
//     } else if (environment === 'development') {
//         return "https://test.sysbrew.in"
//     }
//     return "https://sarathi.sunviksteels.com/api"
// }

export const URLS = {
    CHECK_MOBILE: `${BASE_URL}/check/mobile`,
    LOGIN: `${BASE_URL}/authenticate`,
    AUTHENTICATE_TOKEN: `${BASE_URL}/token`,
    COMPLETE_PROFILE: `${BASE_URL}/complete/profile`,
    CHANGE_PASSWORD: `${BASE_URL}/change/password`,
    EDIT_PROFILE: `${BASE_URL}/edit/profile`,
    REGISTER_NOTIFICATION_URL: `${BASE_URL}/notification/register`,
    UNREGISTER_NOTIFICATION_URL: `${BASE_URL}/notification/unregister`,
    NOTIFICATIONS_URL: `${BASE_URL}/notifications`,
    MARK_NOTIFICATION_READ_URL: `${BASE_URL}/notification/mark/{operation}/{notificationId}`,

    SUPPLIER_LIST: `${BASE_URL}/customer/suppliers`,
    SUPPLIER_STATUS: `${BASE_URL}/customer/supplier/{clientCode}/status`,
    BRANCH_LIST: `${BASE_URL}/customer/branches`,
    SUPPLIER_ACCESS_LOG: `${BASE_URL}/customer/supplier/log`,

    MANUFACTURERS_LIST: `${BASE_URL}/manufacturers`,
    CATEGORIES_LIST: `${BASE_URL}/categories`,
    PRODUCTS_LIST: `${BASE_URL}/products`,
    PRODUCT_REMARKS: `${BASE_URL}/products/remarks`,
    PRODUCTS_NEW_ARRIVALS_COUNT: `${BASE_URL}/products/new-arrivals/count`,
    PRODUCTS_OFFER_PRODUCTS_COUNT: `${BASE_URL}/products/offer-products/count`,
    PRODUCTS_SPECIAL_OFFERS_COUNT: `${BASE_URL}/products/special-offers/count`,

    CART_URL: `${BASE_URL}/cart`,
    CART_ID_URL: `${BASE_URL}/cart/{id}`,
    ORDER_URL: `${BASE_URL}/order`,
    ORDER_HISTORY_URL: `${BASE_URL}/order/history`,
    ORDER_DETAILS_URL: `${BASE_URL}/order/{billNo}`,

    OUTSTANDINGS_URL: `${BASE_URL}/outstandings`,
    OUTSTANDING_URL: `${BASE_URL}/outstanding`,

    LEDGER_URL: `${BASE_URL}/ledger`,
}